module.exports = __webpack_public_path__ + "static/img/14001019.6e6fa15c.png";